import styled from 'styled-components'
import { Image } from '@sainsburys-tech/bolt'

export const AccordionContainer = styled.div`
  background: transparent;
`

export const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: ${props => props.theme.font.weight.bold};
  cursor: pointer;
`

export const TitleAndLogosContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`

export const LabelImage = styled(Image)`
  vertical-align: middle;
  margin-right: 16px;
`

export const AccordionTitleChevronContainer = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: ${props => props.theme.font.size['label-1']};
  width: 100%;
`

export const AccordionTitle = styled.div`
  display: flex;
  justify-content: flex-start;
`

export const IconsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 2px 0 4px 0;
`

export const Terms = styled.div`
  font-size: ${props => props.theme.font.size.caption};
  margin: 8px 0 8px 0;
`

export const AccordionContentWrapper = styled.div`
  margin-top: 16px;
`

export const AccordionContent = styled.div.attrs(() => ({
  'data-test': 'finance-accordion-content'
}))`
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  visibility: hidden;
  transition: max-height 0s ease, opacity 0.3s ease;
  -webkit-font-smoothing: never;

  &.open {
    max-height: 500px;
    opacity: 1;
    visibility: visible;
    transition: max-height 0.5s ease, opacity 0.3s ease;
  }
`
